import { render, staticRenderFns } from "./DescriptionItem.vue?vue&type=template&id=0020a90a&"
import script from "./DescriptionItem.vue?vue&type=script&lang=ts&"
export * from "./DescriptionItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports